module.exports = {"654326100":"托普铁热克镇","654326101":"吉木乃镇","654326102":"喀尔交镇","654326103":"乌拉斯特镇","654326201":"托斯特乡","654326202":"恰勒什海乡","654326204":"别斯铁热克乡","654326500":"兵团一八六团"}


//////////////////
// WEBPACK FOOTER
// ./src/town/654326.json
// module id = 3149
// module chunks = 0